<template>
  <div class="container-fluid">
    <div class="row g-0" style="width: 100vw">
      <span class="border-bottom">
        <button
          class="btn btn-sip-details"
          @click="toggleSipDetails"
          :style="{ color: sipColor }"
        >
          SIP Details
        </button>
        <button
          v-show="transferStore.currentSip?.name"
          class="btn btn-folder-structure"
          @click="toggleFolderStructure"
          :style="{ color: folderColor }"
        >
          Folder Structure
        </button>
      </span>
      <div v-show="showSipDetails">
        <sip-item class="details" :sip-id="currentSipId">SIP Details</sip-item>
      </div>
      <div v-show="showFolderStructure">
        <folder-structure class="folder">Folder Structure</folder-structure>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SipItem from "../SipDetail/SipItem.vue";
import FolderStructure from "./FolderStructure.vue";
import { useTransferStore } from "@/stores/content_review/transfer";
import { ref, watch } from "vue";

const showSipDetails = ref(true);
const showFolderStructure = ref(false);
const sipColor = ref("blue");
const folderColor = ref("black");
const transferStore = useTransferStore();
const currentSipId = ref("");

watch(
  () => transferStore.currentSip?.sipId,
  (sipId) => {
    currentSipId.value = sipId;
  }
);

function toggleFolderStructure() {
  showSipDetails.value = false;
  showFolderStructure.value = true;
  sipColor.value = "black";
  folderColor.value = "blue";
}

function toggleSipDetails() {
  showSipDetails.value = true;
  showFolderStructure.value = false;
  sipColor.value = "blue";
  folderColor.value = "black";
}
</script>

<style lang="scss" scoped>
.container-fluid {
  position: relative;
  float: left;
  display: flex;
  padding: 16px;
  max-width: 33.3vw;
  margin-bottom: 50px;
  overflow: auto;
}
.btn-sip-details {
  border: none;
  width: 50%;
}
.btn-folder-structure {
  border: none;
  width: 50%;
}
</style>
